import axios from "axios";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.loadChart();
  }

  loadChart() {
    let url = this.data.get("url");
    let chartPanelId = "#" + this.data.get("chart-panel-id");

    if (url) {
      axios
        .get(url, { headers: { Accept: "application/json" } })
        .then(response => {
          let chartData = response.data;
          let type = this.data.get("type");

          showChartPanel(chartPanelId);

          switch (type) {
            case "accounts_receivable":
              initAccountsReceivableChart(chartData);
              break;
            case "accounts_statistics":
              initAccountsStatisticsChart(chartData);
              break;
            case "revenue":
              initRevenueChart(chartData);
              break;
            case "performance_per_account":
              initPerformancePerAccountChart(chartData);
              break;
          }
        })
        .catch(error => {
          showCardLoadError(this.element, error);
        });
    }
  }
}
